import { Button, Form, Grid, Input, Select } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { useGetRoleTypes } from 'features/users/use-cases/get-roleTypeList';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EndUserFilterFormField, EndUserFilterFormValues } from './types';

const { Option } = Select;
const { useBreakpoint } = Grid;

type UsersFilterFormProps = {
  formId: string;
  handleFilter: (values: EndUserFilterFormValues) => void;
  initialValues: EndUserFilterFormValues;
  closeModal?: () => void;
    onRefresh :  () => void ;
 
};

export const EndUsersFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
   onRefresh 
  
}: UsersFilterFormProps) => {
  const { t } = useTranslation();
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<EndUserFilterFormValues>();
  const screens = useBreakpoint();
  const { data: roleTypeFilterList, isLoading: roleTypeFilterLoading } = useGetRoleTypes();

  const onReset = () => {
    form.resetFields();
    handleFilter(initialValues);
    onRefresh();
  };

  const onFinish = (formValues: EndUserFilterFormValues) => {
    handleFilter(formValues);
    closeModal?.();
  };

  if (roleTypeFilterLoading) return null;

  if (!roleTypeFilterList || !Array.isArray(roleTypeFilterList) || roleTypeFilterList.length === 0) {
    return <div>No roles available</div>;
  }

  return (
    <Form<EndUserFilterFormValues>
      id={formId}
      name={formId}
      className="filters-form"
      form={form}
      layout="vertical"
      onFinish={onFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper className="cf_frm" style={{ width: '100%' }}>
        <StandardItemsWrapper className="cf_frm_row" style={{ width: '100%' }}>
          <div className="invoice_list" style={{ width: '100%' }}>
            <Form.Item<EndUserFilterFormValues>
              label={t('adminUsers.formFields.userName.label')}
              name={EndUserFilterFormField.FullUserName}
            >
              <Input placeholder={t('adminUsers.formFields.userName.placeholder')} />
            </Form.Item>

            <Form.Item<EndUserFilterFormValues>
              label={t('adminUsers.formFields.email.label')}
              name={EndUserFilterFormField.Email}
            >
              <Input placeholder={t('adminUsers.formFields.email.placeholder')} />
            </Form.Item>

            <Form.Item<EndUserFilterFormValues>
              label={t('adminUsers.formFields.role.label')}
              name={EndUserFilterFormField.Role}
            >
              <Select placeholder="Select role type" style={{ width: 200 }}>
                <Option key={0} value={0}>
                  Select Role Type
                </Option>

                {roleTypeFilterList.map((role) => (
                  <Option key={role.id + 1} value={role.id}>
                    {role.title}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {screens.lg && (
              <ContentFilters.ButtonsWrapper className="filter_btn">
                <Button type="primary" htmlType="submit">
                  {t('common.buttons.filter', { count: 1 })}
                </Button>
                <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
              </ContentFilters.ButtonsWrapper>
            )}
          </div>
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>
    </Form>
  );
};
